
import { ApolloClient, InMemoryCache, gql } from '@apollo/client';
// @ts-ignore
import { unparse as convertToCSV } from 'papaparse/papaparse.min';
import { downloadCSV } from 'react-admin'
import { apolloClient as client } from "../data-provider/graphqlDataProvider";

// let token: any = localStorage.getItem('credentials')
// const client = new ApolloClient({
//     uri: `${process.env.REACT_APP_DATAPROVIDER}`,
//     headers: { authorization: token },
//     cache: new InMemoryCache({
//         addTypename: false,
//         resultCaching: false
//     }),
//     defaultOptions: {
//         watchQuery: {
//             fetchPolicy: 'no-cache',
//             errorPolicy: 'ignore',
//         },
//         query: {
//             fetchPolicy: 'no-cache',
//             errorPolicy: 'all',
//         },
//     }
// });

export async function getDiscountList(params: any) {
    const GET_Discounts = gql`
    query discounts($where: DiscountWhereInput, $orderBy: [DiscountOrderByInput!], $skip: Float, $take: Float) {
        items: discounts(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
          code
          count
          countPerUser
          createdAt
          createdBy
          description
          discountType
          expiryDate
          id
          isEnabled
          meta
          name
          products
          startDate
          tags
          updatedAt
          updatedBy
          usedDiscounts {
            id
            __typename
          }
          __typename
        }
        total: _discountsMeta(
          where: $where
          orderBy: $orderBy
          skip: $skip
          take: $take
        ) {
          count
          __typename
        }
      }
      
  `;
    let filterData = deleteNullPropertyValueDiscountFilter(params.filter);
    console.log('discount params: ', params);

    const query: any = {
        query: GET_Discounts,
        variables: {
            where: { ...filterData },
            skip: params.pagination.perPage * (params.pagination.page - 1),
            take: params.pagination.perPage,
            orderBy: {}
        }
    }

    query.variables["orderBy"][params.sort?.field || "createdAt"] =
        (params.sort?.order
            ? (params.sort.order.length > 1
                ? params.sort.order[0] + params.sort.order.slice(1).toLowerCase()
                : params.sort.order.toLowerCase())
            : "Desc")
    return client.query(query)
}

export async function getDiscount(params: any) {
    const GET_Discount = gql`
    query discount($where: DiscountWhereUniqueInput!) {
        discount(where: $where) {
          code
          count
          countPerUser
          createdAt
          createdBy
          description
          discountType
          expiryDate
          id
          isEnabled
          meta
          name
          products
          startDate
          tags 
          updatedAt
          updatedBy
          usedDiscounts {
            id
            status
          } 
        } 
      }`;

    return client.query({
        query: GET_Discount,
        variables: {
            where: { id: params.id }
        }
    })
}

var exportExcelResult: Array<any> = []

export async function getDiscountForExportExcel(skip: number, filterData: any) {
    const GET_Discounts = gql`
    query discounts($where: DiscountWhereInput, $orderBy: [DiscountOrderByInput!], $skip: Float, $take: Float) {
        items: discounts(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
          code
          count
          countPerUser
          createdAt
          createdBy
          description
          discountType
          expiryDate
          id
          isEnabled
          meta
          name
          products
          startDate
          tags
          updatedAt
          updatedBy
          usedDiscounts {
            id
            __typename
          }
          __typename
        }
        total: _discountsMeta(
          where: $where
          orderBy: $orderBy
          skip: $skip
          take: $take
        ) {
          count
          __typename
        }
      }
      
  `;
    await client.query({
        query: GET_Discounts,
        variables: {
            where: { ...filterData },
            take: 200,
            skip: skip
        }
    }).then(async (res) => {
        let discountResult: Array<any> = res.data.items;

        if (discountResult.length === 200)
            await getDiscountForExportExcel(skip + 200, filterData)
        discountResult.forEach(discount => {
            exportExcelResult.push(discount)
        })
    })
}

export const deleteNullPropertyValueDiscountFilter = (filter: any) => {
    let filterData = { ...filter }
    if (!filterData.code.contains)
        delete filterData.code
    if (!filterData.description.contains)
        delete filterData.description

    if (filterData.createdBy === "BOTH")
        delete filterData.createdBy
    else if (filterData.createdBy === "ADMIN")
        filterData.createdBy = { not: 'LIMOOME_SHOP' }
    else if (filterData.createdBy === "SYSTEM")
        filterData.createdBy = { equals: 'LIMOOME_SHOP' }

    if (filterData.tags.length === 0)
        delete filterData.tags
    else if (filterData.tags.length > 0) {
        console.log('filterData.tags.length > 0: ', filterData.tags);
        const tags = filterData.tags;
        delete filterData.tags
        console.log('tags: ', tags);
        filterData.tags = { hasSome: tags.map((tag: any) => tag.label) }
    }

    console.log('deleteNullPropertyValueDiscountFilter: ', filterData);
    return filterData
}

export const exporter = async (filterList: any) => {
    exportExcelResult = []
    const filterData = deleteNullPropertyValueDiscountFilter(filterList)
    await getDiscountForExportExcel(0, filterData)
    const discountsForExport = exportExcelResult.map((discount: any) => {
        let result = { ...discount }
        result.meta = JSON.stringify(discount.meta)
        result.tags = JSON.stringify(discount.tags)
        return result;
    });
    const csv = convertToCSV({
        data: discountsForExport,
        // select and order fields in the export
        fields: ['code', 'count', 'countPerUser', 'createdBy', 'description', 'discountType', 'expiryDate', 'isEnabled', 'meta', 'startDate', 'tags']
    });
    const BOM = '\uFEFF'
    downloadCSV(`${BOM} ${csv}`, 'discounts' + new Date().toLocaleDateString('fa-IR-u-nu-latn').replaceAll('/', '')); // download as 'posts.csv` file
}